import React, { useRef } from 'react';
import '../App.css';

const VideoComponent = ({ src }) => {
  // reference for video element
  const videoRef = useRef(null);

  // retrieve stored video url from localstorage
  const url = localStorage.getItem('videoUrl');

  // play video in full screen mode
  const playFullscreen = () => {
    const videoElement = videoRef.current;

    if (videoElement.requestFullscreen) {
      videoElement.requestFullscreen();
    } else if (videoElement.mozRequestFullScreen) {
      videoElement.mozRequestFullScreen();
    } else if (videoElement.webkitRequestFullscreen) {
      videoElement.webkitRequestFullscreen();
    } else if (videoElement.msRequestFullscreen) {
      videoElement.msRequestFullscreen();
    }
  };


  // render the video
  return (
    <div className="container">
      <div className="video-section">
        <video ref={videoRef} controls>
          <source src={`${src}/${url}`} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <button onClick={playFullscreen}>Play Fullscreen</button>
      </div>
    </div>
  );
};

export default VideoComponent;
